/**
 * @description 告警管理 dutyManagement
 * @author 系统生成
 * @date 2021/08/07
 */

import Logic from '../logic-base'

const dutyManagementBiz = new Logic()

dutyManagementBiz.getDutyList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dutyManagement.getDutyList,
    data: data
  })
};

dutyManagementBiz.saveDuty = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dutyManagement.saveDuty,
    data: data
  })
};

dutyManagementBiz.updateDuty = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dutyManagement.updateDuty,
    data: data
  })
};

dutyManagementBiz.getUsers = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dutyManagement.getUsers,
    data: Object.assign({ group: '006' }, data)
  })
};

export default dutyManagementBiz
